import { CostItem, FinancialSummary, OrderInfo } from '../types/budget';

export const calculateTotalValue = (qty: number, unitPrice: number): number => {
  return qty * unitPrice;
};

export const calculatePercentage = (itemValue: number, totalOrderValue: number): number => {
  return totalOrderValue > 0 ? (itemValue / totalOrderValue) * 100 : 0;
};

export const calculateFinancialSummary = (
  orderInfo: OrderInfo,
  allCostItems: CostItem[]
): FinancialSummary => {
  const totalCost = allCostItems.reduce((sum, item) => sum + item.totalValue, 0);
  const totalCostPercentage = orderInfo.exportValue > 0 ? (totalCost / orderInfo.exportValue) * 100 : 0;
  const profit = orderInfo.exportValue - totalCost;
  const profitPercentage = orderInfo.exportValue > 0 ? (profit / orderInfo.exportValue) * 100 : 0;
  
  // Calculate final CM per dozen (based on the Excel formula)
  const cmItems = allCostItems.filter(item => item.category === 'CM');
  const totalCmCost = cmItems.reduce((sum, item) => sum + item.totalValue, 0);
  const finalCmPerDz = orderInfo.expQty > 0 ? (totalCmCost / orderInfo.expQty) * 12 : 0;
  
  // Calculate final MC earning (based on the Excel formula)
  const finalMcEarning = orderInfo.prodHour && orderInfo.mcCost && orderInfo.noOfMc
    ? (orderInfo.prodHour * orderInfo.mcCost * orderInfo.noOfMc) / (orderInfo.expQty / 12)
    : 0;

  // Additional calculations from Grok's suggestion
  const contributionMarginPerUnit = orderInfo.pricePerPc - (totalCost / orderInfo.expQty);
  const breakevenUnits = contributionMarginPerUnit > 0 ? Math.ceil(totalCost / contributionMarginPerUnit) : 0;

  return {
    totalCost,
    totalCostPercentage,
    profit,
    profitPercentage,
    finalCmPerDz,
    finalMcEarning,
    contributionMarginPerUnit,
    breakevenUnits,
  };
};

export const calculateMaterialConsumption = (
  orderQty: number,
  yarnItems: CostItem[]
) => {
  const totalYarnQty = yarnItems.reduce((sum, item) => sum + item.qty, 0);
  const yarnPerDz = orderQty > 0 ? (totalYarnQty / orderQty) * 12 : 0;
  
  // Find lycra item if exists
  const lycraItem = yarnItems.find(item => item.description.toLowerCase().includes('lycra'));
  const lycraPerDz = lycraItem && orderQty > 0 ? (lycraItem.qty / orderQty) * 12 : 0;
  
  return {
    yarnPerDz,
    lycraPerDz,
    greyConsPerDz: yarnPerDz + lycraPerDz,
    fabricConsPerDz: yarnPerDz * 1.12, // 12% increase for fabric consumption
    darkColor: 0,
    lightColor: 0,
    white: 0,
    wash: 0,
    total: yarnPerDz * 1.12,
  };
};

export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(amount);
};

export const formatNumber = (num: number, decimals: number = 2): string => {
  return num.toFixed(decimals);
};
